import React, { ReactNode } from 'react';
import { css } from 'emotion';
import { theme } from '@weave/theme-original';
import { Text } from '@weave/design-system';

import { Dot } from '../../shared/atoms/Dot';
import { PaymentsProcessor } from '@weave/schema-gen-ts/dist/schemas/payments-platform/payments-config/payments_config.pb';

const activeMerchantTitleWrapper = css`
  display: flex;
  flex-direction: column;
`;

const activeMerchantWrapper = css`
  display: flex;
`;

const payoutsPaymentsStatuses = css`
  display: flex;
  justify-content: space-between;
  box-shadow: ${theme.shadows.light};
  padding: 10px;
  background-color: #f5f5f5;
  min-width: 240px;
  border-radius: ${theme.borderRadius.medium};
`;

const accounts = css`
  margin-left: 20px;
  padding: 10px;
  background-color: #f5f5f5;
  min-width: 240px;
  max-width: 300px;
  border-radius: ${theme.borderRadius.medium};
  overflow: hidden;
  padding-bottom: 5px;
  box-shadow: ${theme.shadows.light};
`;

const titleStyle = css`
  margin: -10px;
  margin-bottom: 5px;
  padding: 5px;
  background-color: ${theme.colors.weaveBlue};
`;

const subtitle = css`
  margin: 0;
`;

const statusesWrapper = css`
  display: flex;
  justify-content: space-between;
  background-color: white;
  width: 100%;
  align-items: center;
  border-radius: ${theme.borderRadius.medium};
  padding: 10px 15px;
`;

const marginReset = css`
  margin: 0;
  &:not(:last-child) {
    margin-right: ${theme.spacing(2)};
  }
`;

type ProcessorType =
  | PaymentsProcessor.PAYMENTS_PROCESSOR_JUSTIFI
  | PaymentsProcessor.PAYMENTS_PROCESSOR_STRIPE;

const merchantInfoTitles: Record<
  ProcessorType,
  { accountId: string; accountType: string }
> = {
  [PaymentsProcessor.PAYMENTS_PROCESSOR_STRIPE]: {
    accountId: 'Stripe Account ID',
    accountType: 'Stripe Account Type',
  },
  [PaymentsProcessor.PAYMENTS_PROCESSOR_JUSTIFI]: {
    accountId: 'JustiFi Account ID',
    accountType: 'JustiFi Business ID',
  },
};

export type ActiveMerchantInfoProps = {
  processorType: ProcessorType;
  accountId: string | undefined;
  accountType: string | undefined;
  SunbitStatus?: ReactNode;
  statusList: {
    feature: string;
    enabled: boolean | undefined;
  }[];
  title?: string;
};

export const ActiveMerchantInfo = ({
  processorType,
  accountId,
  accountType,
  SunbitStatus,
  statusList,
  title,
}: ActiveMerchantInfoProps) => {
  return (
    <div className={activeMerchantTitleWrapper}>
      {title && (
        <Text size="large" weight="bold">
          {title}
        </Text>
      )}
      <div className={activeMerchantWrapper}>
        <div className={payoutsPaymentsStatuses}>
          <div className={statusesWrapper}>
            {statusList.map((status) => (
              <Text key={status.feature} className={marginReset} weight="semibold">
                {status.feature}
                <Dot isActive={!!status.enabled} />
              </Text>
            ))}
            {SunbitStatus && (
              <Text className={marginReset} weight="semibold">
                Sunbit BNPL
                {SunbitStatus}
              </Text>
            )}
          </div>
        </div>
        <div className={accounts}>
          <Text
            color="white"
            textAlign="center"
            weight="semibold"
            size="medium"
            className={titleStyle}
          >
            {(processorType && merchantInfoTitles[processorType].accountId) ||
              'Account ID'}
          </Text>
          <Text textAlign="center" className={subtitle}>
            {accountId || '-'}
          </Text>
        </div>
        <div className={accounts}>
          <Text
            color="white"
            textAlign="center"
            weight="semibold"
            size="medium"
            className={titleStyle}
          >
            {(processorType && merchantInfoTitles[processorType].accountType) ||
              'Account Type'}
          </Text>
          <Text textAlign="center" className={subtitle}>
            {accountType || '-'}
          </Text>
        </div>
      </div>
    </div>
  );
};
